import React from "react";
import { observer } from "mobx-react";

import { Button } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import Locked from "../locked";

import confirm from "../../confirm";
import Group from "../group";

import "./style/report.scoped.scss";

const Card = observer(({ value, index, readonly = false, onRemove, onEdit, canRemove }) => {
    /**
     * Handle edit button click
     */
    const edit = (event) => {
        event.preventDefault();
        onEdit && onEdit(value);
    };

    /**
     * Handle delete button click
     */
    const remove = async (event) => {
        event.preventDefault();

        let proceed = await confirm("Are you sure you want to remove this entry?");
        if (proceed) {
            onRemove && onRemove(value, event);
        }
    };

    return (
        <Group.Item id={value._id || "new"} index={index} disableDrag={readonly}>
            <div className="report">
                <div className="text">{value.reportName}</div>

                {!readonly && (
                    <div className="actions">
                        <div className="icons">
                            <Button onClick={edit} type="icon" icon={<EditOutlined />}></Button>
                            {!canRemove && <Locked />}
                            {canRemove && (
                                <Button
                                    onClick={remove}
                                    type="icon"
                                    danger
                                    icon={<DeleteOutlined />}
                                ></Button>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </Group.Item>
    );
});

export default Card;
